import { useState } from 'react';
import { Link } from 'react-router-dom';
import { CATEGORIES } from '@/mocks/comics';

const SUBMIT_ADDR = 'https://readdy.ai/api/form/da0kmd6859p3u981e3qg';

export default function Footer() {
  const [status, setStatus] = useState<{ type: 'idle' | 'loading' | 'success' | 'error'; msg: string }>({
    type: 'idle',
    msg: '',
  });

  const scrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  async function handleSubscribe(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);
    const honeypot = String(fd.get('company_alt') || '').trim();
    if (honeypot) {
      setStatus({ type: 'success', msg: '感谢订阅！最新推荐将第一时间送到你的邮箱。' });
      form.reset();
      return;
    }
    const email = String(fd.get('email') || '').trim();
    if (!email) {
      setStatus({ type: 'error', msg: '请输入有效的邮箱地址后再订阅。' });
      return;
    }
    setStatus({ type: 'loading', msg: '正在提交…' });
    try {
      const res = await fetch(SUBMIT_ADDR, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(fd as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: any = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '';
      if (res.ok && parsed?.code === 'OK') {
        setStatus({ type: 'success', msg: '订阅成功！欢迎加入漫画岛的读者大家庭。' });
        form.reset();
      } else {
        setStatus({ type: 'error', msg: serverMsg || '订阅失败，请稍后再试。' });
      }
    } catch {
      setStatus({ type: 'error', msg: '网络异常，请稍后再试。' });
    }
  }

  return (
    <footer className="bg-background-900 text-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-book-2-fill text-xl"></i>
              </span>
              <span className="font-heading text-2xl text-background-50">漫画岛</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-300">
              漫画岛发现好漫频道，编辑精选每日推荐热门新作与潜力佳作。想找下一部入坑作品，来漫画岛探索推荐，挖掘好货不踩雷，追更从此有方向。
            </p>
            <div className="mt-5 flex items-center gap-2 text-sm text-background-300">
              <i className="ri-mail-line"></i>
              <span>contact@manhuadao.cn</span>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-bold uppercase tracking-wider text-background-200">热门分类</h3>
            <ul className="mt-4 grid grid-cols-2 gap-2">
              {CATEGORIES.slice(0, 6).map((c) => (
                <li key={c.slug}>
                  <Link
                    to={`/category/${c.slug}`}
                    onClick={scrollTop}
                    className="inline-flex items-center gap-1.5 text-sm text-background-300 hover:text-accent-300"
                  >
                    <i className={`${c.icon} text-base`}></i>
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold uppercase tracking-wider text-background-200">快速导航</h3>
            <ul className="mt-4 space-y-2">
              {[
                { label: '首页', to: '/' },
                { label: '发现好漫', to: '/category/reXue' },
                { label: '编辑精选', to: '/category/riChang' },
                { label: '关于我们', to: '/about' },
              ].map((l) => (
                <li key={l.label}>
                  <Link to={l.to} onClick={scrollTop} className="text-sm text-background-300 hover:text-accent-300">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold uppercase tracking-wider text-background-200">订阅推荐</h3>
            <p className="mt-4 text-sm leading-relaxed text-background-300">
              每周精选好漫推荐，第一时间送达你的邮箱。
            </p>
            <form id="newsletter-form" data-readdy-form className="mt-4 space-y-3" onSubmit={handleSubscribe}>
              <div className="flex items-center gap-2 rounded-full border border-background-700 bg-background-800 p-1.5 focus-within:border-accent-500">
                <i className="ri-mail-send-line pl-2 text-lg text-background-400"></i>
                <input
                  type="email"
                  name="email"
                  autoComplete="email"
                  placeholder="输入你的邮箱"
                  className="w-full bg-transparent text-sm text-background-50 outline-none placeholder:text-background-500"
                />
              </div>
              <div className="side-note-meta">
                <input type="text" name="company_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
              </div>
              <button
                type="submit"
                className="w-full whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
              >
                {status.type === 'loading' ? '提交中…' : '立即订阅'}
              </button>
              {status.type === 'success' && (
                <p className="text-sm text-accent-300">{status.msg}</p>
              )}
              {status.type === 'error' && <p className="text-sm text-primary-400">{status.msg}</p>}
            </form>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-800 pt-6 text-sm text-background-400 sm:flex-row">
          <p>© 2026 漫画岛 ManHuaDao.cn · 发现好漫，从此追更不迷路</p>
          <div className="flex items-center gap-4">
            <a href="#" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-background-700">
              <i className="ri-weibo-line"></i>
            </a>
            <a href="#" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-background-700">
              <i className="ri-bilibili-line"></i>
            </a>
            <a href="#" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-background-700">
              <i className="ri-wechat-line"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}